// Module
var code = "<div>\n\t<span class=\"neg\">\n\t\t<span class=\"downvote\"></span>\n\t\t{{neg}}%\n\t</span>\n\t<div class=\"separator\"></div>\n\t<span class=\"pos\">\n\t\t<span class=\"upvote\"></span>\n\t\t{{pos}}%\n\t</span>\n\t<div class=\"sentiment-overall\">\n\t\t{{overall}}\n\t</div>\n</div>\n";
// Exports
module.exports = code;